import { SectionCard } from "@blueprintjs/core";
import { ScenarioMetadata } from "in_queue/types/scenarioType";
import { ScenarioAssumptionsSection } from "../ScenarioAssumptions";
import css from "../ScenarioAssumptions.module.scss";

export const InputDataSection: React.FC<{ scenario: ScenarioMetadata }> = ({
    scenario
}) => {
    const description = scenario.inputDataUsed ? (
        <>
            <p>
                Input data: <strong>{scenario.inputDataUsed?.concise}</strong>
            </p>
            <p style={{ whiteSpace: "pre-wrap" }}>
                Input files: <em>{scenario.inputDataUsed?.description}</em>
            </p>
        </>
    ) : (
        <p>No input data provided for this scenario.</p>
    );
    return (
        <ScenarioAssumptionsSection section="inputData" title="Input Data">
            <SectionCard
                padded={false}
                className={`${css["scenario-assumptions-card"]}`}
            >
                {description}
            </SectionCard>
        </ScenarioAssumptionsSection>
    );
};
